/**
 * Inject SDK styles into the document.
 *
 * The stylesheet lives in `src/styles.css` and is imported with Vite's
 * `?inline` query so it is minified at build time and baked into the bundle as
 * a string. This keeps the SDK a single embeddable file (no extra CSS request)
 * while shipping the smallest possible payload. See `src/styles.css` for the
 * source styles and the `--pr-*` / `.pr-*` customization surface.
 */
import styles from '../styles.css?inline';

const STYLE_ID = 'pr-sdk-styles';

export function injectStyles(): void {
    // Avoid injecting the stylesheet more than once per document.
    if (document.getElementById(STYLE_ID)) {
        return;
    }

    const styleElement = document.createElement('style');
    styleElement.id = STYLE_ID;
    styleElement.textContent = styles;
    document.head.appendChild(styleElement);
}
